export const testimonials = [
  {
    id: 1,
    name: "Carlos Mendoza",
    location: "Yopal, Casanare",
    rating: 5,
    date: "2026-01-15",
    comment: "Excelente servicio, recibí mi licencia de Windows 11 Pro en menos de 10 minutos. Todo funcionó perfectamente y el precio fue increíble comparado con otras tiendas.",
    product: "Windows 11 Pro",
    verified: true,
    ownerResponse: "¡Muchas gracias Carlos! Nos alegra que hayas tenido una experiencia tan rápida y satisfactoria. La rapidez en la entrega es una de nuestras prioridades. ¡Esperamos verte pronto!"
  },
  {
    id: 2,
    name: "Marina López",
    location: "Bogotá, Cundinamarca",
    rating: 5,
    date: "2026-01-10",
    comment: "Compré Office 2021 Professional Plus y estoy muy contenta. El proceso de activación fue sencillo y el soporte me ayudó cuando tuve una duda. 100% recomendado.",
    product: "Office 2021 Professional Plus",
    verified: true,
    ownerResponse: "¡Gracias Marina! Nos encanta saber que nuestro equipo de soporte pudo ayudarle. Estamos aquí para lo que necesitas. ¡Saludos a Bogotá!"
  },
  {
    id: 3,
    name: "Andrés Ramírez",
    location: "Yopal, Casanare",
    rating: 4,
    date: "2026-01-08",
    comment: "Muy buen servicio, aunque la página de pago se demoró un poco en cargar. La licencia llegó rápido y funciona perfecto. Volveré a comprar.",
    product: "Windows 10 Pro",
    verified: true,
    ownerResponse: "Gracias por tu feedback Andrés. Lamentamos la demora en la carga, estamos trabajando para optimizar la velocidad del sitio. ¡Nos alegra que la licencia funcione perfecto!"
  },
  {
    id: 4,
    name: "Juan Martínez",
    location: "Bogotá, Cundinamarca",
    rating: 5,
    date: "2026-01-05",
    comment: "Primera vez que compro licencias digitales y quedé impresionada. Todo muy profesional, precios justos y entrega inmediata. Ya les recomendé a mis amigos.",
    product: "Office 2019 Professional Plus",
    verified: true,
    ownerResponse: "¡Bienvenida Juan! Nos emociona ser tu primera experiencia con licencias digitales. Gracias por recomendarnos, eso significa mucho para nosotros. 🎉"
  },
  {
    id: 5,
    name: "Diego Herrera",
    location: "Yopal, Casanare",
    rating: 5,
    date: "2026-01-02",
    comment: "Llevo 3 años comprando aquí y nunca me han fallado. Precios competitivos, atención rápida y licencias originales. Son mi tienda de confianza.",
    product: "Windows 11 Pro",
    verified: true,
    ownerResponse: "¡Diego, eres un cliente estrella! 3 años de confianza son un honor para nosotros. Gracias por tu lealtad, seguiremos dándote el mejor servicio. 🌟"
  },
  {
    id: 6,
    name: "Elmira Rojas",
    location: "Bogotá, Cundinamarca",
    rating: 4,
    date: "2025-12-28",
    comment: "Buena experiencia en general. Me hubiera gustado tener factura electrónica, pero la licencia funciona bien y el precio es excelente.",
    product: "Office 2021 Home & Business",
    verified: true,
    ownerResponse: "Gracias Elmira. Tomamos nota sobre la factura electrónica, estamos trabajando para implementar esa opción pronto. ¡Apreciamos tu sugerencia!"
  },
  {
    id: 7,
    name: "Santiago López",
    location: "Yopal, Casanare",
    rating: 5,
    date: "2025-12-22",
    comment: "Increíble relación calidad-precio. Compré licencias para toda mi oficina y el descuento por volumen fue genial. Soporte técnico muy atento.",
    product: "Windows 10 Pro (x5)",
    verified: true,
    ownerResponse: "¡Gracias Santiago! Nos alegra poder apoyar a tu oficina con nuestros descuentos por volumen. Si necesitas más licencias, cuenta con nosotros. 💼"
  },
  {
    id: 8,
    name: "Carlos Rodríguez",
    location: "Yopal, Casanare",
    rating: 5,
    date: "2026-01-15",
    comment: "Excelente servicio, compré Windows 11 Pro y llegó en menos de 2 horas. El proceso de pago con Nequi fue muy fácil. Totalmente recomendado.",
    product: "Windows 11 Pro",
    verified: true,
    ownerResponse: "¡Perfecta Carlos! Nos encanta que hayas usado Nequi y que el tutorial te haya sido útil. Estamos para ayudarte siempre. 😊"
  },
  {
    id: 9,
    name: "Julián Castro",
    location: "Yopal, Casanare",
    rating: 4,
    date: "2025-12-15",
    comment: "Buen servicio, aunque no encontré instrucciones claras en la página sobre cómo activar la licencia. Tuve que contactar soporte, pero me ayudaron rápido.",
    product: "Office 2019 Home & Student",
    verified: true,
    ownerResponse: "Gracias por tu comentario Julián. Vamos a mejorar las instrucciones en la página para que sean más claras. ¡Nos alegra que el soporte te haya ayudado rápido!"
  },
  {
    id: 10,
    name: "Yeison Vargas",
    location: "Bogotá, Cundinamarca",
    rating: 5,
    date: "2025-12-10",
    comment: "Excelente atención al cliente. Tenía dudas sobre qué versión de Office comprar y me asesoraron perfectamente. Muy satisfecha con mi compra.",
    product: "Office 2021 Professional Plus",
    verified: true,
    ownerResponse: "¡Gracias Yeison! Nuestro equipo está capacitado para asesorarte en la mejor opción. Nos alegra haberte ayudado a elegir correctamente. 🎯"
  },
  {
    id: 11,
    name: "Mateo Jiménez",
    location: "Yopal, Casanare",
    rating: 5,
    date: "2025-12-05",
    comment: "Compré para mi empresa y todo perfecto. Licencias originales, precios justos y entrega inmediata. Ya hice mi segunda compra.",
    product: "Windows 11 Pro (x10)",
    verified: true,
    ownerResponse: "¡Mateo, gracias por confiar en nosotros para tu empresa! Es un placer servirte. Cualquier necesidad futura, aquí estamos. 🚀"
  },
  {
    id: 12,
    name: "Luis Morales",
    location: "Bogotá, Cundinamarca",
    rating: 4,
    date: "2025-11-28",
    comment: "Muy buena experiencia. La única sugerencia es que agreguen más opciones de pago. De resto, todo excelente.",
    product: "Windows 10 Home",
    verified: true,
    ownerResponse: "Gracias Luis. Estamos trabajando en agregar más métodos de pago para mayor comodidad. ¡Tu sugerencia es muy valiosa! 💳"
  },
  {
    id: 13,
    name: "Lucas Fernández",
    location: "Yopal, Casanare",
    rating: 5,
    date: "2025-11-20",
    comment: "Mejor precio del mercado sin duda. Comparé con varias tiendas y aquí encontré la mejor oferta. Licencia funcionando al 100%.",
    product: "Office 2021 Home & Business",
    verified: true,
    ownerResponse: "¡Gracias Lucas! Trabajamos duro para ofrecer los mejores precios sin sacrificar calidad. ¡Nos alegra que hayas elegido bien! 💰"
  },
  {
    id: 14,
    name: "Marcos Ruiz",
    location: "Bogotá, Cundinamarca",
    rating: 5,
    date: "2025-11-12",
    comment: "Servicio impecable. Compré Windows 11 Pro y Office 2021, ambas licencias llegaron al instante y se activaron sin problemas. Totalmente recomendado.",
    product: "Windows 11 Pro + Office 2021",
    verified: true,
    ownerResponse: "¡Marcos, qué alegría! Nos encanta cuando todo sale perfecto. Gracias por tu recomendación, significa mucho para nosotros. ✨"
  }
];

export const testimonialStats = {
  averageRating: 4.9,
  totalReviews: 620,
  fiveStars: 82,
  fourStars: 14,
  threeStars: 3,
  twoStars: 1,
  oneStar: 0,
  recentReviews: 187
};
